import cn from 'classnames';
import React from 'react';
import {t} from '@lingui/core/macro';


import styles from './Availability.module.scss';

interface AvailabilityProps {
    periodDay: number;
    periodWeek: number;
    periodMount: number;
}

const Availability: React.FC<AvailabilityProps> = ({periodDay, periodWeek, periodMount}) => {

    const periods = [
        {value: periodDay, label: t`24 часа`, isBigText: true},
        {value: periodWeek, label: t`7 дней`, isBigText: false},
        {value: periodMount, label: t`Месяц`, isBigText: false},
    ];

    const getAvailabilityClass = (availability: number): string =>
        availability >= 99
            ? styles.high
            : styles.low;

    return (
        <div className={styles.availability}>
            {periods.map(({value, label, isBigText}, index) => (
                <div
                    key={index}
                    className={cn(
                        styles.availability_block,
                        getAvailabilityClass(value),
                    )}
                >
                    <div className={cn(
                        styles.period,
                        styles.periodColor,
                        getAvailabilityClass(value),
                    )}>
                        {label}
                    </div>
                    <span className={cn(styles.value, {[styles.bigText]: isBigText})}>
                        {value}%
                    </span>
                </div>
            ))}
        </div>
    );
};

export default Availability;

